import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const UserThankyou = () => {
  const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
  return (
    <>
      <Header />
      <PageHeader pagename="Thank you for Visiting" />
      <section className="thankyou">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 mx-auto">
              <div className="text-center main-profile-content radius-20 p-4 position-relative">
                <h4 className="main-heading-font level-6 mt-3 mb-3">
                  {orderdetail?.physician_detail?.title}
                </h4>
                <h5 className="primary-medium-font level-8 extra-color-10">
                  Thank you for letting me be part of your healthcare journey.
                </h5>
                <div className="thankyou-btn edit-btn back position-absolute ">
                  <Link to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}>
                    <div className="nav-anchor">
                      <i className="fa-solid fa-xmark"></i>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserThankyou;
